import axios from 'axios';

interface INumerologyNameResponse {
    /** Nome como a API recebeu, depois do anti-injection. */
    name: string;
    /** Número de expressão pelo método pitagórico. */
    value: number;
}

export const fetchNumerologyNumber = async (name: string): Promise<number> => {
    const { data } = await axios.get<INumerologyNameResponse>(
        `${window.API_URL}/orakle/numerology/name/${encodeURIComponent(name)}`
    );

    return data.value;
};
